var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1234_2650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.07151 7.07107C10.9768 3.16583 17.3084 3.16583 21.2136 7.07107C25.1189 10.9763 25.1189 17.308 21.2136 21.2132C17.3084 25.1184 10.9768 25.1184 7.07151 21.2132C3.16627 17.308 3.16627 10.9763 7.07151 7.07107Z",
    fill: "#3DCBB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19343 7.19298C11.0313 3.35507 17.2538 3.35507 21.0917 7.19298C24.9296 11.0309 24.9296 17.2534 21.0917 21.0913C17.2538 24.9292 11.0313 24.9292 7.19342 21.0913C3.35551 17.2534 3.35551 11.0309 7.19343 7.19298Z",
    stroke: "white",
    strokeOpacity: 0.23,
    strokeWidth: 0.344828
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1234_2650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1079 13.9205L16.186 10.9752C16.0513 10.8405 15.8325 10.8385 15.6978 10.9733C15.563 11.108 15.561 11.3268 15.6958 11.4616L18.0337 13.819H9.55322C9.36182 13.819 9.20752 13.9733 9.20752 14.1647C9.20752 14.3561 9.36182 14.5104 9.55322 14.5104H18.0337L15.6958 16.8678C15.561 17.0026 15.563 17.2213 15.6978 17.3561C15.8325 17.4909 16.0513 17.4889 16.186 17.3541L19.1079 14.4088C19.2407 14.2741 19.2407 14.0553 19.1079 13.9205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1234_2650",
    x: -6.89606,
    y: -6.89655,
    width: 42.0773,
    height: 42.0774,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.44828
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1234_2650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1234_2650",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1234_2650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(9.20508 8.47314)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrowRight);
export default __webpack_public_path__ + "static/media/green-arrow-right.10c3b876978619d86a3332b1527a82ae.svg";
export { ForwardRef as ReactComponent };